module.exports = __webpack_public_path__ + "fonts/NotoSansLao-Regular.e13494c.ttf";